// import { createSlice } from "@reduxjs/toolkit";

// const answersSlice = createSlice({
//   name: "answer",
//   initialState: {
//     answer:[],
//   },
//   reducers: {
// addAnswer: (state, action) => {
//   state.answer.push(action.payload);
// },
//  },
// });

// export const { addAnswer } = answersSlice.actions;
// export default answersSlice.reducer;

import { createSlice } from "@reduxjs/toolkit";

const answersSlice = createSlice({
  name: "answer",
  initialState: {
    answer: [],
  },
  reducers: {
    addAnswer: (state, action) => {
      const { question, is_correct,course } = action.payload;

const existing = state.answer.find(
  a => a.question === question && a.course === course
);
      if (existing) {
        existing.count += 1;      // زيادة عدد المحاولات
        existing.is_correct = is_correct; // تحديث آخر نتيجة
      } else {
        state.answer.push({
          question,
          is_correct,
          count: 1,
          course
        });
      }
    },
        clearAnswers: (state) => {
      state.answer = [];
    }
  },
});

export const { addAnswer,clearAnswers } = answersSlice.actions;
export default answersSlice.reducer;
